import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogClickSearchPromotion = (screenName: string) => {
  return useCallback(
    (params: { title: string; deeplink: string }) => {
      bridge.logAnalyticsEvent({
        channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
        name: 'CLICK_SEARCH_PROMOTION',
        analytics: {
          SCREEN: screenName,
          TITLE: params.title,
          DEEPLINK: params.deeplink,
        },
      });
    },
    [screenName],
  );
};
